exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".top-session-button[data-v-e639cc16]{padding:8px 15px;font-size:var(--font-small);border-radius:8px;font-weight:var(--font-weight-medium)}.top-session-button__container[data-v-e639cc16]{margin-right:10px}.top-session-button__container .button__primary[data-v-e639cc16],.top-session-button__container .button__secondary[data-v-e639cc16]{border:0}.top-session-button__container .button__secondary.outline[data-v-e639cc16]{font-weight:var(--font-weight-bold)}", ""]);

// exports
